// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__smWdx","box":"WorkspacesBox_box__3qy9b","node":"WorkspacesBox_node__1wdrZ"};